import { createReducer } from "@reduxjs/toolkit";
import { refreshUserInvitation, resetRefreshUserInvitation } from "./refresh-user-invitation";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const refreshUserInvitationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(refreshUserInvitation.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(refreshUserInvitation.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(refreshUserInvitation.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetRefreshUserInvitation, () => {
    return initialState;
  });
});
